export const PlanIDEnum = (v: string) => {

  const planIDEnum = [
    {
      planID: "104001",
      evShareToMerchant: 0,
    },
    {
      planID: "104002",
      evShareToMerchant: 15,
    },
    {
      planID: "104003",
      evShareToMerchant: 20, 
    },
    {
      planID: "104004",
      evShareToMerchant: 25,
    },
  ]

  const planID = planIDEnum.find(item => item.planID === v)

  return planID
}
